import { Container, Button, Card, Row, Col, Form } from 'react-bootstrap';

import { useState, useEffect, useRef } from 'react';
import {
    Accordion,
    Tag,
    ColorPicker,
    SelectButton,
    InputNumber,
    FileUpload,
    Dialog,
    InputTextarea,
} from 'primereact';
import { useAuthentication, useTheme } from 'hooks';
import DropZone from 'components/DropZone/Dropzone';
import { GridView } from 'components';
import ToolTip from 'components/ToolTip/ToolTip';
import IconButton from 'components/IconButton/IconButton';
import { SvgComponent } from 'components';
import uuid from 'react-uuid';
import Select from 'react-select'
import { DateTimePicker } from "components";
import InputContainer from 'components/PantallasEdit/InputContainer/InputContainer';
import useMessage from 'hooks/useMessage';
import usePaginationValuesWhere from 'hooks/usePaginationValuesWhere';
import useExceptionHandler from 'hooks/useExceptionHandler';
import { FacturaCitrusManager as manager, AuthenticationManager } from "managers";
import { DateHelper, DEFAULT_PAGINATION_VALUES } from 'utils';
import { useMiCuenta } from 'hooks/useMiCuenta';
import { useLocalStorage } from 'hooks';
import { ERP_URL } from 'utils';
import ReporteViewer from "components/Reportes/ReporteViewer";

const ESTATUS_CANCELADA = "C";
const ESTATUS_FACTURADA = "F";
const ESTATUS_PAGADA = "P";
const ESTATUS_CANCELADA_LABEL = "Cancelada";
const ESTATUS_FACTURADA_LABEL = "Facturada";
const ESTATUS_PAGADA_LABEL = "Pagada";

let isListenerActive = false;
let numeroFactura = null;
export function FacturasSection({ showLoading, hideLoading }) {
    const dialogPagoRef = useRef(null)
    const [pagoModalVisible, setPagoModalVisible] = useState(false);
    const [body, setBody] = useState(null);
    const [header, setHeader] = useState(null)
    const base64ref = useRef(null);
    const fileTypeRef = useRef(null);
    const contentTypeRef = useRef(null);
    const archivoRef = useRef({ File: null });
    const [showCanvasReporte, setShowCanvasReporte] = useState(false);
    const [reporte, setReporte] = useState(undefined);
    const [dateTimeKey, setDateTimeKey] = useState("fechasKey");
    const { Message, Error, Warning } = useMessage();
    const { handleException } = useExceptionHandler();

    const ESTATUS_LIST = [
        { value: "", label: "Todos" },
        {
            value: ESTATUS_CANCELADA,
            label: ESTATUS_CANCELADA_LABEL,
        },
        {
            value: ESTATUS_FACTURADA,
            label: ESTATUS_FACTURADA_LABEL,
        },
        {
            value: ESTATUS_PAGADA,
            label: ESTATUS_PAGADA_LABEL,
        },
    ];
    const [facturasList, setFacturasList] = useState([]);
    const [pagination, setPagination] = useState(DEFAULT_PAGINATION_VALUES);
    const [dropZoneKey, setDropZoneKey] = useState("dropZone - first");
    const { setPaginationValuesWhere } = usePaginationValuesWhere();
    const [whereModal, setWhereModal] = useState({});
    const [archivo, setArchivo] = useState({ File: null });
    const { theme } = useTheme();
    const consultaActualId = useRef();
    const { usuario } = useAuthentication();

    const { montoPendiente,
        setMontoPendiente,
        montoColor,
        setMontoColor,
        montoTotal,
        setMontoTotal,
    } = useMiCuenta();

    const onPageIndexChanging = (pageNumber) => {
        setPagination((prevstate) => {
            return { ...prevstate, IndiceDePagina: pageNumber - 1 };
        });
        setWhereModal({ ...whereModal });
    };

    const transferenciaDescRef = useRef(null)
    const pagoTransferenciaBody = (NumeroFactura) => {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', margin: '0 20px' }}>
                <h3>Cuenta Bancaria</h3>
                <p className='bootstrapiso' style={{ marginTop: '0' }}>
                    <span className='font-weight-bold'>Banco</span>: Banco Popular Dominicano
                    <br />
                    <span className='font-weight-bold'>Tipo</span>: Cuenta Corriente
                    <br />
                    <span className='font-weight-bold'>Número</span>: 769921859
                    <br />
                    <span className='font-weight-bold'>Propietario</span>: Citrus Technology Group SRL
                    <br />
                    <span className='font-weight-bold'>RNC</span>: 130815348
                    <br />
                </p>
                <h3>Comprobante</h3>

                <InputContainer label="Seleccione un archivo">
                    <DropZone
                        key={dropZoneKey}
                        styles={{ marginLeft: "0px" }}
                        label="Dé click o arrastre la Imagen para continuar"
                        multiple={false}
                        updateFilesCb={(f) => customBase64Uploader(f, "File")}
                        type="image-pdf"
                        files={[]}
                        useVideo={false}
                    />
                </InputContainer>
                <h3>Descripcion</h3>
                <InputTextarea ref={transferenciaDescRef} rows={5} cols={30} />
                <div className='bootstrapiso'>
                    <div className="d-flex justify-content-center mt-3">
                        <Button type="button"
                            style={{ backgroundColor: theme.color1, color: '#fff' }}
                            onClick={(e) => {
                                e.preventDefault()
                                onHidePagoModal()
                                handleUploadTranferencia(NumeroFactura);
                            }} className="btn btn-success btn-lg form-control">Enviar</Button>

                    </div>
                </div>
            </div>
        )
    }

    useEffect(() => buscar(), [whereModal]);
    useEffect(() => autenticar(), []);

    const customBase64Uploader = (propFile, propName) => {
        setArchivo(prevArchivo => {
            const updatedArchivo = { ...prevArchivo, [propName]: propFile };
            return updatedArchivo;
        });

        archivoRef.current = { ...archivoRef.current, [propName]: propFile };
    };

    const descargarArchivo = () => {
        showLoading();
        const link = document.createElement("a");
        link.target = "_blank";
        manager
            .descargarFormularioAutorizacionCargoTarjetaCredito("")
            .then((res) => {
                const link = document.createElement("a");
                link.href = URL.createObjectURL(res);
                link.download = "Formulario de Autorización.pdf";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(link.href);
            })
            .catch((error) => {
                handleException(error);
            })
            .finally(() => hideLoading());
    };

    function validarArchivos(file) {
        let messages = [];
        if (!file) {
            messages.push("Debe subir un archivo tipo imagen o pdf.")
        } else if (!file.name.endsWith('.pdf')
            && !file.name.endsWith('.jpeg')
            && !file.name.endsWith('.jpg')
            && !file.name.endsWith('.png')) {
            messages.push("Debe incluir una imagen o documento de la autorización de pago. Formatos aceptados: [.pdf, .jpg, .jpeg, .png].")
        }
        if (messages.length > 0) {
            Warning({ messages: messages });
        }
        return messages.length === 0;
    }

    const handleUploadTranferencia = (NumeroFactura) => {
        setPagoModalVisible(false)
        showLoading();
        const currentFile = archivoRef.current.File;
        if (
            currentFile === null ||
            currentFile === undefined ||
            currentFile.length === 0
        ) {
            Warning({ message: "Debe seleccionar un archivo para continuar." });
            hideLoading();
            return;
        }

        const descripcion = transferenciaDescRef.current?.value || "";
        const payload = {
            File: archivoRef.current.File,
            NumeroFactura: NumeroFactura,
            Descripcion: descripcion
        };

        manager.procesarComprobantePago(payload)
            .then((res) => {
                if (res.Ok) {
                    Message({ message: `Comprobante de Pago Enviado Exitosamente` });
                    setArchivo({ File: null });
                    archivoRef.current = { File: null };
                    setDropZoneKey(uuid());
                } else {
                    Message({ message: `El archivo no pudo ser cargado correctamente, intente de nuevo.` });
                }
            })
            .catch((e) => handleException(e))
            .finally(() => hideLoading());
    };

    function enviarFormulario() {
        showLoading();

        const currentFile = archivoRef.current.File;
        if (
            currentFile === null ||
            currentFile === undefined ||
            currentFile.length === 0
        ) {
            Warning({ message: "Debe seleccionar un archivo para continuar." });
            hideLoading();
            return;
        }

        manager.procesarFormularioAutorizacion({ ...archivoRef.current })
            .then((res) => {
                if (res.Ok) {
                    Message({ message: `Formulario Enviado Exitosamente` });
                    setArchivo({ File: null });
                    archivoRef.current = { File: null };
                    setDropZoneKey(uuid());
                } else {
                    Message({
                        message: `El archivo no pudo ser cargado correctamente, intente de nuevo.`,
                        type: Types.TYPE_WARNING,
                    });
                }
            })
            .catch((e) => handleException(e))
            .finally(() => hideLoading());
    }


    const pagoRecurrenteBody = () => {
        return (
            <div className='bootstrapiso' style={{ padding: '0 20px 10px 20px' }}>
                <h3>Formulario</h3>
                <InputContainer label="Seleccione un archivo">
                    <DropZone
                        key={dropZoneKey}
                        styles={{ marginLeft: "0px" }}
                        label="Dé click o arrastre el archivo pdf para continuar"
                        multiple={false}
                        updateFilesCb={(f) => customBase64Uploader(f, "File")}
                        type="pdf"
                        files={[]}
                        useVideo={false}
                    />
                </InputContainer>

                <Button type="button" style={{ backgroundColor: "#ffffff", color: "#000000", border: "none" }} onClick={() => { descargarArchivo() }}
                    className="btn btn-lg form-control">Haz click aqui para descargar formulario de Pago Recurrente</Button>

                <div className="d-flex justify-content-center mt-3">
                    <Button type="button" style={{ backgroundColor: theme.color1, color: "#ffffff" }} onClick={() => {
                        setPagoModalVisible(false)
                        handleUploadRecurrente();
                    }} className="btn btn-success btn-lg form-control">Enviar</Button>
                </div>
            </div>

        )
    }

    const handleUploadRecurrente = () => {
        enviarFormulario();
    };

    const handleClick = (tipo, estatus = null, total = null, idSec = null, FacturasPendientes = false) => {
        let messages = []
        if (tipo !== 'Recurrente') {
            if (estatus === "Pagada") {
                Warning({ message: 'Solo puede pagar facturas pendientes de cobro.' })
                return;
            }
            if (total <= 0) {
                Warning({ message: 'Solo puede pagar facturas con un monto pendiente mayor a 0.' })
                return;
            }
        }

        switch (tipo) {
            case 'Transferencia':
                setHeader('Envio de Comprobante de Pago')
                setBody(pagoTransferenciaBody(idSec))
                setPagoModalVisible(true)
                break;
            case 'Tarjeta':
                obtenerLinkPago(idSec, FacturasPendientes);
                break;
            case 'Recurrente':
                setHeader("Descarga y llena el formulario");
                setBody(pagoRecurrenteBody)
                setPagoModalVisible(true)
                break;
            default:
                break;
        }
    };


    const onViewReport = (IdSec) => {
        showLoading();
        manager.buscarReporte(IdSec)
            .then((res) => {
                setReporte(res.Data);
                setShowCanvasReporte(true);
            })
            .catch((err) => {
                handleException(err);
            })
            .finally(() => hideLoading());
    };

    function onHidePagoModal() {
        setPagoModalVisible(false)
    }


    function buscar() {
        const whereWithPaginationValues = {
            ...whereModal,
            ...pagination,
            FechaInicio: whereModal.RangoFechas?.fechaInicio,
            FechaFin: whereModal.RangoFechas?.fechaFin,
        };

        manager.listado(whereWithPaginationValues)
            .then((res) => {
                setPaginationValuesWhere(res.Headers, pagination, setPagination);
                setFacturasList(res.Data.Resultados);
                setMontoPendiente(res.Data.montoFormateado);
                setMontoTotal(res.Data.montoPendiente);
                setMontoColor(res.Data.montoFormateado > 0 ?? 'red');
            })
            .catch((err) => handleException(err))
            .finally(() => hideLoading());
    }

    function actualizarFactura(numeroFactura) {
        showLoading();
        const facturaRequest = {
            NumeroFactura: numeroFactura,

        }
        manager.actualizarPorNumeroFactura(facturaRequest)
            .then((res) => {
                buscar()
            })
            .catch((err) => handleException(err))
            .finally(() => hideLoading());
    }

    function autenticar() {
        AuthenticationManager.autenticarERPAPI()
            .then((res) => {

            })
            .catch((err) => handleException(err))
            .finally(() => hideLoading());
    }

    function handleMessage(event) {
        if (event.origin !== ERP_URL) return;
        if (!event.data || !event.data.info || !event.data.info.exito) return;

        if (event.data && event.data.info.exito) {
            Message({ message: `Pago realizado con éxito. Número de Autorización: ${event.data.info.numeroAutorizacion}` });
            let numeroFactura = event.data.info.numeroFactura;
            if (numeroFactura) {
                actualizarFactura(numeroFactura);
            }
        }

        window.removeEventListener("message", handleMessage);
        isListenerActive = false;
    }

    function obtenerLinkPago(NumeroFactura, FacturasPendientes) {
        const facturaRequest = {
            NumeroFactura: `${NumeroFactura}`,
            FacturasPendientes: FacturasPendientes,
        }

        showLoading();
        manager.obtenerLinkPagoFactura(facturaRequest)
            .then((res) => {
                if (res.Success && res.Data) {
                    const width = 960;
                    const height = 500;
                    const left = (window.screen.width / 2) - (width / 2);
                    const top = (window.screen.height / 2) - (height / 2);
                    const origin = window.location.origin;

                    const url = `${res.Data.Url}&requestOrigin=${encodeURIComponent(origin)}`
                    const popup = window.open(
                        url,
                        "_blank",
                        `width=${width},height=${height},left=${left},top=${top}`
                    );
                    window.removeEventListener("message", handleMessage);
                    if (!isListenerActive) {
                        window.addEventListener("message", handleMessage);
                        isListenerActive = true;
                    }
                } else {
                    handleException(res);
                }
            })
            .catch((err) => handleException(err))
            .finally(() => hideLoading());
    }

    return (
        <div>
            <Dialog ref={dialogPagoRef} header={header} visible={pagoModalVisible} style={{ width: '50vw' }} breakpoints={{ '1280': '50vw', '960px': '75vw', '641px': '450px', '400px': '350px' }} onHide={onHidePagoModal}
                pt={{
                    root: {
                        style: {
                            backgroundColor: '#fff',
                            borderRadius: '8px',
                            overflow: 'hidden'
                        }
                    },
                    header: { style: { backgroundColor: theme.color1, color: '#fff', borderRadius: '6px', margin: '10px', padding: '10px' } },
                    closeButtonIcon: { style: { color: '#fff' } },
                    mask: {
                        style: {
                            zIndex: '900003',
                            backgroundColor: 'rgba(0, 0, 0, 0.4)'
                        }
                    }
                }}
            >
                {body}

            </Dialog>

            {showCanvasReporte && (
                <ReporteViewer
                    showCanvas={showCanvasReporte}
                    setShowCanvas={setShowCanvasReporte}
                    reporte={reporte}
                />
            )}

            <Container>
                <div className='flex flex-column' style={{ width: '100%' }}>

                    <h2 style={{ fontWeight: 'bold', color: '#6c757d' }}>
                        Balance Pendiente:&nbsp;
                        <span style={{ color: parseInt(montoTotal) > 0 ? 'red' : 'inherit' }}>{montoPendiente}</span>
                    </h2>

                    <div className='d-flex gap-4 mb-4' style={{
                        maxWidth: '800px',
                        padding: '0.5rem'
                    }}>
                        <Button
                            type="button"
                            style={{
                                flex: 1,
                                height: 'auto',
                                minHeight: '40px',
                                maxWidth: ' 250px',
                                backgroundColor: theme.color1,
                                borderRadius: '6px',
                                borderColor: theme.color1,
                                padding: '0 10px',
                                margin: '0 8px 0 0',
                                fontSize: '16px',
                            }}
                            onClick={() => handleClick('Tarjeta', null, montoTotal, 0, true)}
                            className="bootstrapiso btn btn-lg"
                        >
                            Pagar Balance Total
                        </Button>
                        <Button
                            type="button"
                            style={{
                                flex: 1,
                                height: 'auto',
                                minHeight: '',
                                maxWidth: ' 250px',
                                backgroundColor: theme.color1,
                                borderRadius: '6px',
                                borderColor: theme.color1,
                                padding: '0 10px',
                                fontSize: '16px',
                            }}
                            onClick={() => handleClick('Recurrente')}
                            className="bootstrapiso btn btn-lg"
                        >
                            Registrar Cargo Recurrente
                        </Button>
                    </div>
                </div>

                <GridView
                    pagination={pagination}
                    setPagination={setPagination}
                    allowPaging={pagination.EsPaginable}
                    pageSize={pagination.CantidadPorPagina}
                    pageIndex={pagination.IndiceDePagina}
                    lastPageNumber={pagination.PaginasTotal}
                    dataSource={facturasList}
                    onPageIndexChanging={onPageIndexChanging}
                    where={whereModal}
                    setWhere={setWhereModal}
                    onReset={() => { setDateTimeKey(uuid()); }}
                >
                    <GridView.Column
                        isSticky
                        bodyRenderer={(row) => {
                            return (
                                <>
                                    <div className="float-right">
                                        <IconButton
                                            onClick={() => {
                                                handleClick("Tarjeta", row._EstatusDesc, row.MontoPendiente, row.NumeroFactura)
                                            }}
                                        >
                                            <ToolTip message="Pago Directo con TC">
                                                <div>
                                                    <SvgComponent
                                                        iconName="credit-card"
                                                        height="28px"
                                                        width="28px"
                                                    />
                                                </div>
                                            </ToolTip>
                                        </IconButton>
                                        <IconButton
                                            onClick={() => handleClick("Transferencia", row._EstatusDesc, row.MontoPendiente, row.NumeroFactura)}                                        >
                                            <ToolTip message="Enviar Comprobante de Pago">
                                                <div>
                                                    <SvgComponent
                                                        iconName="email"
                                                        height="25px"
                                                        width="25px"
                                                    />
                                                </div>
                                            </ToolTip>
                                        </IconButton>
                                        <IconButton onClick={() => onViewReport(row.IdSec)}>
                                            <ToolTip message="Reporte">
                                                <div>
                                                    <SvgComponent
                                                        iconName="print"
                                                        height="25px"
                                                        width="25px"
                                                    />
                                                </div>
                                            </ToolTip>
                                        </IconButton>
                                    </div>
                                </>
                            );
                        }}
                    />
                    <GridView.Column
                        headerText="ID"
                        dataField="IdSec"
                        sortExpression="IdSec"
                    />
                    <GridView.Column
                        headerText="Referencia"
                        dataField="NumeroFactura"
                        sortExpression="NumeroFactura"
                    />
                    <GridView.Column
                        headerText="Fecha"
                        dataField="Fecha"
                        sortExpression="Fecha"
                        width="200px"
                        filterRenderer={(onInputChange) => {
                            return (
                                <DateTimePicker
                                    key={dateTimeKey}
                                    esRangoFechas
                                    esGrid
                                    labelFechaInicio="Inicio"
                                    labelFechaFin="Fin"
                                    usarLabel={false}
                                    fechaInicioOriginal={whereModal?.FechaInicio ? whereModal.FechaInicio : ""}
                                    fechaFinOriginal={whereModal?.FechaFin ? whereModal.FechaFin : ""}
                                    onChange={(e) => {
                                        onInputChange({
                                            target: { name: "RangoFechas", value: e },
                                        })
                                    }}
                                />
                            );
                        }}
                        bodyRenderer={(row) => {
                            const fecha = DateHelper.formatStringDate(row.Fecha, false);
                            return (
                                <div className="mx-2" style={{ textAlign: "left" }}>
                                    {fecha}
                                </div>
                            );
                        }}
                    />
                    <GridView.Column
                        headerText="Estatus"
                        dataField="_EstatusDesc"
                        sortExpression="Estatus"
                        width="150px"
                        filterRenderer={(onInputChange) => {
                            return (
                                <Select
                                    className="basic-single"
                                    classNamePrefix="select"
                                    options={ESTATUS_LIST}
                                    value={ESTATUS_LIST.filter(function (option) {
                                        return (
                                            option.value ===
                                            (whereModal.Estatus ? whereModal.Estatus : ESTATUS_LIST[0].value)
                                        );
                                    })}
                                    name="Estatus"
                                    onChange={(e) =>
                                        onInputChange({ target: { name: "Estatus", value: e.value } })
                                    }
                                />
                            );
                        }}
                    />
                    <GridView.Column
                        headerText="NCF"
                        dataField="NCF"
                        sortExpression="NCF"
                    />
                    <GridView.Column
                        headerText="Total"
                        dataField="Total"
                        sortExpression="Total"
                        searchField="Total"
                        number
                    />
                </GridView>
            </Container>
        </div>
    )
}